import Loadable from 'react-loadable';

export const ReactionUpdateAction = Loadable({
  loader: () => import(/* webpackChunkName: "ReactionUpdateAction" */ './ReactionUpdateAction'),
  loading: () => null,
});

export { reactionUpdateActionResource } from './resource';
